module.exports = __webpack_public_path__ + "static/img/case_detail_01_3.274a94d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_01_3.png
// module id = kgvJ
// module chunks = 34